// Note the frontend permissions just show/hide UI elements. The backend permissions are the source of truth for what a user can actually do. The frontend permissions are just a convenience to avoid showing users things they can't do, but they don't actually enforce any security.

import { Role } from 'src/AppContext';
import { isGmgAdminRole, isOrganizationGroupAdminRole } from 'src/role';

interface HasUserPermissionToViewParentOrganizationParams {
    userRole: Role | undefined;
    userOrgId: string | undefined;
    parentOrganizationId: string | undefined;
}

const hasUserPermissionToViewParentOrganization = (params: HasUserPermissionToViewParentOrganizationParams): boolean => {

    const { userRole, userOrgId, parentOrganizationId } = params;
    const hasGmgAdminPermission = isGmgAdminRole(userRole);
    const hasOrganizationGroupAdminPermission = isOrganizationGroupAdminRole(userRole);
    const isUserInParentOrganization = !!userOrgId && userOrgId === parentOrganizationId;

    return hasGmgAdminPermission || hasOrganizationGroupAdminPermission || isUserInParentOrganization;
};

export { hasUserPermissionToViewParentOrganization };